/**
 * v-scroll-reveal 指令
 * 元素进入视口时添加 .is-visible 类,配合 CSS 实现滚动入场动画
 *
 * 用法:
 *   <div v-scroll-reveal>默认向上弹出</div>
 *   <div v-scroll-reveal="'scale'">从小变大</div>
 *   <div v-scroll-reveal="{ type: 'left', delay: 200 }">从左滑入,延迟 200ms</div>
 *   <div v-scroll-reveal="{ type: 'right', delay: 300, threshold: 0.2 }">从右滑入</div>
 *
 * type 可选: 'up'(默认) | 'down' | 'left' | 'right' | 'scale' | 'fade'
 */
const observers = new WeakMap()

function getObserver(options) {
  const threshold = options.threshold != null ? options.threshold : 0.15
  const rootMargin = options.rootMargin || '0px 0px -10% 0px'
  return new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const el = entry.target
        const delay = el.__scrollRevealDelay__ || 0
        window.setTimeout(() => {
          el.classList.add('is-visible')
        }, delay)
        // 一次性触发,触发后停止观察
        const obs = observers.get(el)
        if (obs) {
          obs.unobserve(el)
          observers.delete(el)
        }
      }
    })
  }, {
    threshold,
    rootMargin
  })
}

export default {
  inserted(el, binding) {
    const options = binding.value || {}
    const type = typeof binding.value === 'string' ? binding.value : (options.type || 'up')
    const delay = typeof options === 'object' ? (options.delay || 0) : 0
    const threshold = typeof options === 'object' ? options.threshold : null
    const rootMargin = typeof options === 'object' ? options.rootMargin : null

    // 给元素添加基础类和动画类型类
    el.classList.add('scroll-reveal')
    if (type && type !== 'up') {
      el.classList.add(`scroll-reveal--${type}`)
    }
    if (delay) {
      el.__scrollRevealDelay__ = delay
      el.classList.add(`scroll-reveal--delay-${Math.min(Math.round(delay / 100), 8)}`)
    } else {
      el.__scrollRevealDelay__ = 0
    }

    // 防止首屏元素在视口内时 IntersectionObserver 不触发(其实会触发,这里仅作保险)
    const observer = getObserver({ threshold, rootMargin })
    observers.set(el, observer)
    observer.observe(el)
  },
  unbind(el) {
    const obs = observers.get(el)
    if (obs) {
      obs.disconnect()
      observers.delete(el)
    }
    delete el.__scrollRevealDelay__
  }
}
